import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlertBoxMsg } from '@qrios/frontend-library';

import Divider from '../../../../common/divider/divider';
import StepperFooter from '../profile-creation/stepperFooter';

import { Status } from './interfaces';
import { statusToSeverity } from './utils';

interface StyleProps {
  status: Status;
}

const useStyles = makeStyles(theme => ({
  container: {
    width: theme.customComponents.profileCreation.container.width,
    maxWidth: '690px',
    padding: theme.spacing(3)
  },
  titleContainer: {
    color: ({ status }: StyleProps) => (status === 'blocked' ? theme.palette.error.main : 'inherit'),
    marginBottom: theme.spacing(2)
  }
}));

interface Props {
  title: string;
  infoText: ReactNode;
  status: Status;
  submitHandler: () => void;
}

const DialogContent = ({ title, infoText, status, submitHandler }: Props) => {
  const classes = useStyles({ status });

  return (
    <Box className={classes.container}>
      <Box className={classes.titleContainer}>
        <Typography color="inherit" align="center" variant="h2">
          {title}
        </Typography>
      </Box>
      <Divider />
      <Box display="flex" alignItems="center" mb={2}>
        <AlertBoxMsg severity={statusToSeverity(status)}>{infoText}</AlertBoxMsg>
      </Box>
      <StepperFooter
        primaryButton={{
          text: 'Proceed to create a new client profile',
          isDisabled: status === 'blocked',
          onClickHandler: status === 'enabled' ? submitHandler : () => {}
        }}
      />
    </Box>
  );
};

export default DialogContent;
